import intl from "react-intl-universal"
import { IJustificationNegotiationProps } from "./types"

const JustificationNegotiation = ({ idLoadComposition, justificationDescriptionValue }: IJustificationNegotiationProps) => {
  return (
    <div>
      <div className="negotiation-read-offer">
        <div className="negotiation-read-column">
          <span>{intl.get('menu.subMenuGeneral.loadComposition')}:</span>
          <span>{idLoadComposition}</span>
        </div>
      </div>
      <div className="negotiation-read-offer">
        <div className="negotiation-read-column">
          {justificationDescriptionValue &&
            <>
              <span>{intl.get('stocks.timeline.justification')}</span>
              <span>{justificationDescriptionValue}</span>
            </>
          }
        </div>
      </div>
    </div>
  )
}

export default JustificationNegotiation;